import styled from 'styled-components';

const StyledCard = styled.div`
  padding: 2.2rem 1.2rem;
  border-radius: 1.6rem;
`;

export default StyledCard;
